import { createSlice } from "@reduxjs/toolkit";

const initialnotificationTemplateState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  notificationTemplateForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  notificationTemplateFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminNotificationTemplateSlice = createSlice({
  name: "notificationTemplate",
  initialState: initialnotificationTemplateState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getnotificationTemplateById
    notificationTemplateFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.notificationTemplateForEdit =
        action.payload.notificationTemplateForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findnotificationTemplate
    notificationTemplatesFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    notificationTemplateReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    notificationTemplateFiles: (state, action) => {
      state.notificationTemplateFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    notificationTemplateFilesFetched: (state, action) => {
      state.notificationTemplateFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
